var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.243,
    height: 29.25,
    viewBox: "0 0 29.243 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-cube",
    "data-name": "Icon ionic-ios-cube",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M30.994,9.105,18.4,3.459a.977.977,0,0,0-.795,0L5.006,9.105a.591.591,0,0,0-.028,1.041l12.565,6.616a.958.958,0,0,0,.914,0l12.565-6.616A.591.591,0,0,0,30.994,9.105Z",
    fill: "#7352ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M19.7,32.548l12.663-6.7a.568.568,0,0,0,.253-.478v-13a.524.524,0,0,0-.752-.5L19.2,18.394a.555.555,0,0,0-.3.5v13.17A.531.531,0,0,0,19.7,32.548Z",
    fill: "#7352ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M3.375,12.368V25.362a.568.568,0,0,0,.253.478l12.663,6.7a.518.518,0,0,0,.788-.478V18.893a.555.555,0,0,0-.3-.5L4.127,11.869A.526.526,0,0,0,3.375,12.368Z",
    fill: "#7352ed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.1c187d1ada12c083aec96dec86c6eb83.svg";
export { ForwardRef as ReactComponent };